import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import AxiosInstance from "../../Services/AxiosInstance";
import { API_ENDPOINTS } from "../../Services/Services";
import { useAuth } from "../../ProtectedRoute/AppContext";
import { toast, ToastContainer } from "react-toastify";
import { IoPersonAdd } from "react-icons/io5";
import { FaUserEdit } from "react-icons/fa";
import { CiLogout } from "react-icons/ci";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router";
import Loader from "../../DesignLayout/Loader/Loader";
const User = () => {
  const { user } = useAuth();
  const {logout}=useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [userData, setUserData] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [Loading,setloading]=useState(false);
  const location = useLocation(); // Track route changes
  const [editedUser, setEditedUser] = useState({
    userId:user.userId,
    userName:'',
    email:'',
    role:0,

  });
  const [addUserMode, setAddUserMode] = useState(false);
  const [role,setrole]=useState([])
const [newUser, setNewUser] = useState({
  userName: "",
    email: "",
    password: "",
    role: 0,
    contact_No:''
  
    });
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await AxiosInstance.get(
          `${API_ENDPOINTS.GET_USER_BYID}?userId=${user.userId}`
        ); 
        const roles=await AxiosInstance.get(`${API_ENDPOINTS.GET_ROLE}`)
        setrole(roles.data || [])
        if (response.data) {
          setUserData(response.data);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchUser();
  }, [user.userId]);

  const handleEditClick = () => {
    setEditedUser(userData);
    setEditMode(true);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditedUser((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    setloading(true);
    try {
      const defaultuser=userData;
      const roles= role.find(x=>x.name===defaultuser.role)
      const merging={
        ...editedUser,
        role:roles.id
      }
      console.log(merging);
      await AxiosInstance.put(API_ENDPOINTS.UPDATE_USER, merging);
      setUserData(editedUser);
      setEditMode(false);
      window.location.reload();
    } catch (error) {
      console.error("Error updating user:", error);
      console.log(userData?.role);
           
    }
    finally{
      setloading(false);
    }
  };

  const addnewuser=async () => {
    setloading(true);
    try {
      await AxiosInstance.post(API_ENDPOINTS.ADD_USER, newUser);
      localStorage.setItem("userpagemessage", "User added successfully!");

      setAddUserMode(false);
      //navigate("/user");
      window.location.reload();
    } catch (error) {
      //console.error("Error adding user:", error);
    }
    finally{
      setloading(false);
    }
  }
  window.onload = () => {
    const message = localStorage.getItem("userpagemessage");
    if (message) {
      toast.success(message);
      localStorage.removeItem("userpagemessage"); // Clear after showing
    }
  };
  return (
    <div className="container-fluid mt-4"><ToastContainer />
    <Loader loading={Loading} />
      <div className="row ">
      {(user.role===1 || user.role===2)&&(
        <div className="col-md-12 text-end justify-content-end mb-4">
          <button className="btn btn-primary" onClick={() => setAddUserMode(true)}>Add New <IoPersonAdd/></button>
        </div>
      )}
        {/* My Profile Section */}
        <div className="col-lg-6 m-auto">
          {loading ? (
            <div className="d-flex justify-content-center">
              <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : userData ? (
            <div className="card p-4 shadow-lg" style={{ maxWidth: "400px", margin: "auto" }}>
   <div className="text-center">
    <img
      src=""
      alt="Profile"
      className="rounded-circle border"
      style={{
        width: "120px",
        height: "120px",
        objectFit: "cover",
        border: "3px solid #007bff",
      }}
    />
    <h5 className="mt-3 mb-0">{userData.userName}</h5>
    <small className="text-muted">Last Login: 27 Aug 2019 14:54</small>
   </div>
   <hr className="my-4" />
   <div className="mt-2">
    <p>
      <i className="bi bi-telephone-fill text-primary me-2"></i>
      <strong>Phone:</strong> {userData.contact_No || "N/A"}
    </p>
    <p>
      <i className="bi bi-envelope-fill text-primary me-2"></i>
      <strong>Email:</strong> {userData.email || "N/A"}
    </p>
    <p>
      <i className="bi bi-person-fill text-primary me-2"></i>
      <strong>Role:</strong> {userData.role || "N/A"}
    </p>
   
   </div>
   <button
    className="btn btn-primary fs-5 w-100 mt-4"
    style={{
      borderRadius: "25px",
      boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
    }}
    onClick={handleEditClick}
   >
    Edit <FaUserEdit size={27} />
   </button>
   </div>

          ) : (
            <p>No user data found.</p>
          )}

   <div className="text-center mt-4">
        <button
   className="btn btn-danger"
   onClick={() => {
    const confirmed = window.confirm("Are you sure you want to logout?");
    if (confirmed) {
      logout(); // Call the logout function if confirmed
    }
    }}
   >
   Logout <CiLogout/>
   </button>
        </div>
        </div>
       
      </div>

      {/* Edit Modal */}
      {editMode && (
        <div
          className="modal show d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Edit Profile</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setEditMode(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <label className="form-label">Name</label>
                  <input
                    type="text"
                    name="userName"
                    value={editedUser.userName || ""}
                    onChange={handleInputChange}
                    className="form-control"
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Phone</label>
                  <input
                    type="text"
                    name="contact_No"
                    value={editedUser.contact_No || ""}
                    onChange={handleInputChange}
                    className="form-control"
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Email</label>
                  <input
                    type="email"
                    name="email"
                    value={editedUser.email || ""}
                    onChange={handleInputChange}
                    className="form-control"
                  />
                </div>
              
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setEditMode(false)}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleSave}
                >
                  Save Changes
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

    {addUserMode && (
  <div
    className="modal show d-block"
    tabIndex="-1"
    style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
  >
    <div className="modal-dialog">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Add New User</h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setAddUserMode(false)}
          ></button>
        </div>
        <div className="modal-body">
          <div className="mb-3">
            <label className="form-label">Name</label>
            <input
              type="text"
              name="userName"
              value={newUser.userName || ""}
              onChange={(e) =>
                setNewUser({ ...newUser, userName: e.target.value })
              }
              className="form-control text-start"
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Email</label>
            <input
              type="email"
              name="email"
              value={newUser.email || ""}
              onChange={(e) =>
                setNewUser({ ...newUser, email: e.target.value })
              }
              className="form-control text-start"
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Role</label>
            <select name="role" id="role" className="border border-1 text-start p-1 rounded form-select" required onChange={(e) =>
                setNewUser({ ...newUser, role: e.target.value })
              }>
              <option value="">Select Role</option>
              {role.map((roles)=>{
                return <option value={roles.id} key={roles.id}>{roles.name}</option>
              })}
            </select>
          </div>
          <div className="mb-3">
  
  
</div>
          <div className="mb-3 ">
            <label className="form-label">Phone</label>
            <input
              type="number"
              name="contact_No"
              
              value={newUser.contact_No || ""}
              onChange={(e) =>
                setNewUser({ ...newUser, contact_No: e.target.value })
              }
              className="form-control text-start"
            />
          </div>
          <div className="mb-3 ">
            <label className="form-label">Password</label>
            <input
              type="password"
              name="password"
              minLength={8}
              value={newUser.password || ""}
              onChange={(e) =>
                setNewUser({ ...newUser, password: e.target.value })
              }
              className="form-control text-start"
            />
          </div>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => setAddUserMode(false)}
          >
            Close
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={addnewuser}
          >
            Save User
          </button>
        </div>
      </div>
    </div>
  </div>
)}


    </div>
  );
};

export default User;
